import { useState, useContext } from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, TextField } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MessengerContext } from "../../../contexts/MessengerContext";

const SchedulerDialog = ({ open, close, handleSend }) => {
    const {sendAt, setSendAt} = useContext(MessengerContext)

    const handleSchedule = () => {
        handleSend();
        close();
    };

    return (
        <Dialog open={open} onClose={close} fullWidth>
            <DialogTitle>Message Scheduler</DialogTitle>
            <DialogContent>
                <DialogContentText sx={{mb: 2}}>Please choose a date/time for when you would like this message to be sent</DialogContentText>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                        label="Select Date & Time"
                        value={sendAt}
                        onChange={(newValue) => setSendAt(newValue)}
                        renderInput={(params) => <TextField {...params} fullWidth margin="normal" />}
                    />
                </LocalizationProvider>
            </DialogContent>
            <DialogActions>
                <Button onClick={close}>Cancel</Button>
                <Button onClick={handleSchedule} variant="contained" disabled={!sendAt}>
                    Schedule
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SchedulerDialog;